import React from 'react';
import { Box, IconButton, Badge, Fade } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';

const ChatToggleButton = ({
  isOpen,
  unreadCount,
  hasNewMessages,
  onToggle,
}) => {
  return (
    <Fade in={!isOpen} timeout={300}>
      <Box 
        className="chat-toggle-button"
        sx={{
          position: 'fixed',
          bottom: { xs: '16px', sm: '24px' },
          right: { xs: '16px', sm: '24px' },
          zIndex: 9998,
        }}
      >
        <Badge
          badgeContent={unreadCount > 0 ? unreadCount : 0}
          color="error"
          max={99}
          invisible={unreadCount === 0}
          className="chat-notification-badge"
        >
          <IconButton
            onClick={onToggle}
            className={`chat-icon-button ${hasNewMessages ? 'has-new-messages' : ''}`}
            size="large"
            aria-label={isOpen ? "Close chat support" : "Open chat support"}
          >
            <ChatIcon />
          </IconButton>
        </Badge>
      </Box>
    </Fade>
  );
};

export default ChatToggleButton;
